  import * as ActionTypes from "../Types/ActionTypes";

  export const BackOffice = (
    state = {
      isLoading: false,
      backOfficeState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.ADMIN_CASE_COUNT_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.ADMIN_CASE_COUNT:
        return {
          ...state,
          isLoading: false,
          backOfficeState: action.payload,
        };

      case ActionTypes.ADMIN_CASE_COUNT_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
